import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadStories from '../loadStories'

const fetchStories = (workspaceId) =>
  HttpClient().get('/api/v1/stories', {
    params: { 'filter[workspace]': workspaceId, limit: 9999 },
  })

const getStories = () => async (dispatch, getState) => {
  const currentState = getState()
  const workspaceId = currentState.current_workspace_id
  if (!workspaceId) return false
  return fetchStories(workspaceId)
    .then((response) =>
      dispatch(loadStories(parseJSONApiResponse(response.data)))
    )
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default getStories
